import React, { useState, useEffect, useCallback } from 'react';
import { REVIEWS_DATA } from '../../data/navigation';
import s from './TestimonialsSection.module.css';

export default function TestimonialsSection() {
  const [page, setPage] = useState(0);
  const perView = () => window.innerWidth < 680 ? 1 : window.innerWidth < 960 ? 2 : 3;
  const [pv, setPv] = useState(3);
  const totalPages = Math.ceil(REVIEWS_DATA.length / pv);

  useEffect(() => {
    const handler = () => setPv(perView());
    window.addEventListener('resize', handler);
    setPv(perView());
    return () => window.removeEventListener('resize', handler);
  }, []);

  const prev = useCallback(() => setPage(p => Math.max(0, p - 1)), []);
  const next = useCallback(() => setPage(p => Math.min(totalPages - 1, p + 1)), [totalPages]);

  const visible = REVIEWS_DATA.slice(page * pv, page * pv + pv);

  return (
    <section className={`section ${s.section}`} id="reviews">
      <div className="container">
        <div className={`${s.header} reveal`}>
          <div className={s.badge}>⭐ Rated Excellent · 619 Verified Google Reviews</div>
          <h2 className="display-heading" style={{marginBottom:'10px'}}>What Our <em>Patients Say</em></h2>
          <p style={{fontSize:'15px',fontWeight:'300',color:'var(--slate-600)'}}>Real words from real patients in the Flourtown, PA community.</p>
        </div>

        <div className={s.grid}>
          {visible.map((review, i) => (
            <div key={review.id} className={`${s.card} reveal reveal-delay-${i}`}>
              <div className={s.quoteIcon}>"</div>
              <div className={s.stars}>{'★'.repeat(review.rating)}</div>
              <p className={s.text}>{review.text}</p>
              <div className={s.author}>
                <div className={s.avatar}>{review.avatar}</div>
                <div>
                  <div className={s.name}>{review.name}</div>
                  <div className={s.date}>{review.date} · Google Review</div>
                </div>
              </div>
            </div>
          ))}
        </div>

       {/*} <div className={s.nav}>
          <div className={s.dots}>
            {Array.from({ length: totalPages }).map((_, i) => (
              <button key={i} className={`${s.dot} ${i === page ? s.dotActive : ''}`} onClick={() => setPage(i)} aria-label={`Page ${i+1}`} />
            ))}
          </div>
          <div className={s.btns}>
            <button className={s.btn} onClick={prev} disabled={page === 0}>←</button>
            <button className={s.btn} onClick={next} disabled={page === totalPages - 1}>→</button>
          </div>
        </div> */}
      </div>
    </section>
  );
}
